<template>
  <div class="manage-tags-table__container" id="data-capture-form-notification">
    <div class="container mt-30">
      <div class="card m-b-30">
        <div class="card-body" v-if="count > 0">
          <div class="mb-35">
            <h4 class="mt-0 tags-title p-15">
              Notifications
              <span class="badge badge-secondary ml-5">{{ count }}</span>
            </h4>
          </div>
          <BaseTable :data="notifications" :columnMetaData="columnMetaData" :columnNames="columnNames" @onSortColumn="onSortColumn">
            <template slot="stepName" slot-scope="{ data }">
              <span class="cursor-pointer capitalize-text">
                {{ getCapitalizedText(data.row.stepName) }}
              </span>
            </template>
            <template slot="userCount" slot-scope="{ data }">
              <div class="d-flex pl-10">
                <b-col :id="`selected-${data.row.notificationId}-unscheduledNotifications`" cols="6" class="form-text p-0 th-form-notification-table-user-list ml-10" tabindex="0" v-if="data.row.contacts && data.row.contacts.length > 1">
                  {{ data.row.contacts.length - 1 }}
                </b-col>
                <b-popover :target="`selected-${data.row.notificationId}-unscheduledNotifications`" triggers="click blur" placement="left" container="data-capture-form-notification">
                  <div class="add-notification-user-pop-over-container" v-if="data.row.contacts && data.row.contacts.length">
                    <ul class="notification-user-list">
                      <li class="notification-user-list-item" v-for="(user, index) in getUserList(data.row.contacts, data.row.contacts[0])" :key="index">
                        {{ user.firstName + " " + user.lastName }}
                      </li>
                    </ul>
                  </div>
                </b-popover>
              </div>
            </template>
            <template slot="firstName" slot-scope="{ data }">
              <span class="th-notification-table-label d-flex">
                {{ data.row.contacts[0].firstName + " " + data.row.contacts[0].lastName }}
              </span>
            </template>
            <template slot="actions" slot-scope="{ data }">
              <img src="static/img/activity-configurator/edit-tag.svg" @click="onEditNotification(data.row)" class="mr-20 cursor-pointer" alt="" />
              <img src="static/img/activity-configurator/delete-tag.svg" @click="onDeleteTag(data.row)" class="cursor-pointer" alt="" />
            </template>
          </BaseTable>
        </div>
        <div class="card-body" v-if="count == 0">
          <div class="mb-35">
            <h4 class="mt-0 tags-title p-15">
              Notifications
              <span class="badge badge-secondary ml-5">{{ count }}</span>
            </h4>
          </div>
          <div class="text-center fs-16 mb-60 font-weight-bold">
            <b>No available notifications.</b>
          </div>
        </div>

        <div class="row display-inline-flex manage-tags-table__pagination mt-40" v-if="count > 0">
          <div class="arrow-icon cursor_pointer" @click="prevPage(-1)" :class="{ disabledPagination: pagination.current <= 1 }">
            <i class="fa fa-angle-left fs-23 pt-3"></i>
          </div>
          <div class="pagination pt-3">
            {{ pagination && pagination.current }}
          </div>
          <div class="pagination2 pt-3">of {{ pagination && pagination.total }}</div>
          <div
            @click="nextPage(1)"
            class="arrow-icon pt-3 cursor_pointer"
            :class="{
              disabledPagination: pagination.current >= pagination.total
            }"
          >
            <i class="fa fa-angle-right fs-23"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseTable from "@/components/activity-library/base-table";
import capitalize from "lodash/capitalize";

const columnMetaData = {
  name: {
    name: "stepName",
    heading: "Step Name",
    contentClasses: ["p-5, pl-30", "name"],
    fixedWidth: "7%",
    sortable: true,
    headerClasses: ["pl-35", "th-notification-table-step-name"],
    isRenderCustomComponent: true
  },

  type: {
    name: "stepType",
    heading: "Step Type",
    contentClasses: ["pt-5 pb-5", "fs-11"],
    fixedWidth: "7%",
    // sortable: true,
    headerClasses: []
  },

  response: {
    name: "triggeringResponse",
    heading: "Triggering Response",
    contentClasses: ["pt-5 pb-5", "fs-12", "text-break"],
    fixedWidth: "56%",
    sortable: false,
    headerClasses: []
  },

  notify: {
    name: "firstName",
    heading: "Notify",
    contentClasses: ["p-5, pl-30", "name"],
    fixedWidth: "7%",
    sortable: true,
    headerClasses: ["pl-35", "th-notify-user"],
    isRenderCustomComponent: true
  },

  userCount: {
    name: "userCount",
    heading: " ",
    contentClasses: ["p-5", "name"],
    fixedWidth: "7%",
    sortable: false,
    headerClasses: ["th-notify-user-count"],
    isRenderCustomComponent: true
  },

  actions: {
    name: "actions",
    heading: "",
    contentClasses: ["pt-5 pb-5"],
    fixedWidth: "10%",
    sortable: false,
    headerClasses: ["th-notification-action"],
    isRenderCustomComponent: true
  }
};

export default {
  data() {
    return {
      columnMetaData,
      columnNames: ["name", "type", "response", "notify", "userCount", "actions"]
    };
  },

  components: {
    BaseTable
  },

  props: {
    notifications: {
      type: Array
    },
    count: {
      type: Number,
      default: 5
    },
    pagination: {}
  },

  mounted() {
    // this.onPageChange(1);
  },

  methods: {
    getUserList(users, firstEle) {
      return users && users.filter(item => item.id != firstEle.id);
    },
    getCapitalizedText(text) {
      return capitalize(text);
    },
    onEditNotification(notification) {
      this.$emit("onEditNotification", notification);
    },
    onDeleteTag(notification) {
      this.$emit("deleteNotification", notification);
    },
    onSortColumn(eventData) {
      this.$emit("onSortColumn", eventData);
    },
    onPageChange(direction) {
      this.$emit("onPageChange", direction);
    },
    nextPage(direction) {
      this.$emit("nextPage", direction);
    },
    prevPage(direction) {
      this.$emit("prevPage", direction);
    }
  }
};
</script>
<style lang="scss">
#data-capture-form-notification {
  .popover {
    width: auto !important;
    margin: 0 !important;
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15);
    background-color: #ffffff;
    left: -8px !important;
    border: none;
    .popover-body {
      margin: 0 !important;
      padding: 0 !important;
    }
  }
}
.text-break {
  word-break: break-word;
}
.th-form-notification-table-user-list {
  width: 35px;
  height: 24px;
  font-size: 14px;
  font-weight: bold;
  color: #4c8ce4;
  border: 1px solid #d3dee3 !important;
  border-radius: 4px;
  text-align: center;
  display: inline-block;
  cursor: pointer;
  line-height: 22px;

  &:focus {
    outline: none;
  }
}
.add-notification-user-pop-over-container {
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15);
  background-color: #ffffff;
  overflow-y: scroll;
  max-height: 258px;
  scrollbar-width: thin; /* "auto" or "thin"  */
  scrollbar-color: #e6e9ed transparent; /* scroll thumb & track */

  &::-webkit-scrollbar {
    width: 5px; /* width of the entire scrollbar */
    max-height: 15%;
  }
  &::-webkit-scrollbar-track {
    background: transparent; /* color of the tracking area */
  }
  &::-webkit-scrollbar-thumb {
    background-color: #b0bac9; /* color of the scroll thumb */
    border-radius: 20px; /* roundness of the scroll thumb */
    border: 3px solid transparent; /* creates padding around scroll thumb */
  }
}
.notification-user-list {
  list-style: none;
  padding: 0 15px 0 10px;
  padding-top: 9px;
}
.notification-user-list-item {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.14;
  letter-spacing: normal;
  color: #000000;
}
.th-notification-table-step-name {
  width: 35%;
}
.th-notify-user {
  width: 13%;
}
.th-notify-user-count {
  width: 7%;
}
.th-notification-action {
  width: 7%;
}
</style>
<style scoped lang="scss">
.capitalize-text {
  word-break: break-word;
}
.th-notification-table-label {
  font-size: 12px !important;
  color: #000;
  font-weight: normal;
  overflow: hidden;
}
.th-fprm-notification-table-user-list {
  width: 35px;
  height: 24px;
  font-size: 14px;
  font-weight: bold;
  color: #4c8ce4;
  border: 1px solid #d3dee3 !important;
  border-radius: 4px;
  text-align: center;
  display: inline-block;
  cursor: pointer;
  line-height: 22px;
  margin-left: 10px;
}
.tag-name {
  height: 24px;
  font-family: "RobotoRegular";
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: #4c8ce4;
}

.description {
  width: 50%;
}

.created-by {
  width: 20%;
}

.actions {
  width: 10%;
}

.tags-title {
  height: 24px;
  font-family: "RobotoRegular";
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #000000;
}

.manage-tags-table {
  &__container {
    margin: 0 auto;

    .card-body {
      padding: 0;
    }

    .container {
      max-width: 100%;
    }

    .card {
      border: none;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
      margin-bottom: 50px;
    }

    .cursor-pointer {
      cursor: pointer;
    }
  }

  &__pagination {
    margin-left: 25px !important;
    margin-bottom: 40px;
  }
}

.badge-secondary {
  background-color: #b0bac9;
  position: relative;
  bottom: 3px;
}
.arrow-icon {
  width: 32px;
  height: 32px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #e4e8eb;
  text-align: center;
  font-size: 23px;
  line-height: 10px !important;
  color: #e4e8eb;
}

.pagination {
  width: 32px;
  height: 32px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #e4e8eb;
  text-align: center;
  font-size: 13px;
  line-height: 23px !important;
  color: #4a4a4a;
  padding-left: 11px !important;
}

.pagination2 {
  width: 40px;
  height: 32px;
  background-color: #ffffff;
  font-size: 13px;
  line-height: 23px !important;
  color: #4a4a4a;
  padding-left: 6px !important;
}

.disabledPagination {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.65 !important;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
